import { Injectable } from 'angular2/core';
import { Response } from 'angular2/http';
import { Observable } from 'rxjs/Observable';
import { ApiClient } from './api-client.service';

@Injectable()
export class Resource {

  constructor(
    public http: ApiClient,
    private resourceUrl: string
  ) { }

  save(resource: HttpResource) : Observable<Response> {
    if (resource.id) {
      return this.http.put(this.buildResourceUrl(resource), JSON.stringify(resource));
    } else {
      return this.http.post(this.resourceUrl, JSON.stringify(resource));
    }
  }

  get(id: string) : Observable<Response> {
    return this.http.get(this.buildResourceUrl({id}));
  }

  delete(resource: HttpResource) : Observable<Response> {
    return this.http.delete(this.buildResourceUrl(resource));
  }

  //TODO(zareone) add query and pagination
  list() : Observable<Response> {
    return this.http.get(this.resourceUrl);
  }

  private buildResourceUrl(resource: HttpResource) : string {
    return this.resourceUrl + '/' + resource.id;
  }
}

interface HttpResource {
  id: string;
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/api/resource.service.ts
 **/